import React, { useEffect, useState } from 'react';

import "../../../css/components/OrderInfo/EditOrderModal/EditOrderModal.css";

import { CreateStaffOrderModalList } from '../../../constants/StaffOrderModal/StaffOrderModal';
import { useUser } from '../../../hooks/useUser';
import { TruckLoanApplicationForm } from '../../TruckLoanApplication/TruckLoanApplicationForm';
import { Message } from '../../../utils/Message';

import { getVehicles } from '../../../service/api/Vehicle/apiVehicle';

const CreateStaffOrderModal = ({ data, onSubmit, onCancel, mode: propMode = 'personal', deliversData }) => {
    // 如果 propMode = 'deliver'，讓用戶選擇 mode；否則直接使用 propMode
    const [selectedMode, setSelectedMode] = useState(propMode === 'deliver' ? 'personal' : propMode);
    const mode = propMode === 'deliver' ? selectedMode : propMode;
    const [showLoanForm, setShowLoanForm] = useState(false);
    const [vehicleInfo, setVehicleInfo] = useState(null);
    const [pendingForm, setPendingForm] = useState(null);
    const [loanFormData, setLoanFormData] = useState(null); // 保存借車申請表單的數據
    const [form, setForm] = useState({
        company: '',
        employeeId: '',
        name: '',
        plate: '',
        phone: '',
        furnitureCount: 0,
        isReturned: "未歸還",
        category: 1,
        status: 0,
        usedAt: '',
        finishAt: '',
        returnAt: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'name') {
            const selectedDeliver = deliversData.find(deliver => deliver.name === value);
            console.log(selectedDeliver);
            const firstVehiclePlate = selectedDeliver?.vehicles?.[0]?.plate || '';
            setForm(prev => ({
                ...prev,
                status: selectedDeliver?.company === '順康資產管理顧問股份有限公司' ? 2 : 0,
                employeeId: selectedDeliver?.id || '',
                phone: selectedDeliver?.phone || '',
                company: selectedDeliver?.company || '',
                isReturned: selectedDeliver?.company === '順康資產管理顧問股份有限公司' ? '未歸還' : '非本公司',
                plate: mode === 'personal' ? firstVehiclePlate : '', // 個人模式自動填入第一輛車牌
            }));

            // 如果是順康公司，取得車輛資訊
            if (selectedDeliver?.company === '順康資產管理顧問股份有限公司' && firstVehiclePlate) {
                fetchVehicleInfo(firstVehiclePlate);
            }
        }

        // 如果選擇了車牌，更新車輛資訊
        if (name === 'plate' && form.company === '順康資產管理顧問股份有限公司') {
            fetchVehicleInfo(value);
        }

        setForm(prev => ({
            ...prev,
            [name]: name === "plate" ? value.toUpperCase() : value
        }));
    };

    // 取得車輛資訊
    const fetchVehicleInfo = async (plate) => {
        try {
            const response = await getVehicles({ plate });
            if (response?.status === 200 && response.data?.result?.length > 0) {
                setVehicleInfo(response.data.result[0]);
            }
        } catch (error) {
            console.error('取得車輛資訊失敗:', error);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // 驗證車牌是否為空
        if (!form.plate || form.plate.trim() === '') {
            alert('請選擇車牌');
            return;
        }

        // 如果是順康公司，需要先填寫借車申請
        if (form.company === '順康資產管理顧問股份有限公司') {
            setPendingForm(form);
            setShowLoanForm(true);
            return;
        }

        console.log(form)
        onSubmit(form);
    };

    // 借車申請送出成功後，繼續提交派車單
    const handleLoanFormSubmit = async (loanApplication) => {
        setShowLoanForm(false);
        // 保留 loanFormData，如有誤可重新編輯
        // setLoanFormData(null);
        if (pendingForm) {
            // 將借車申請資訊附加到派車單
            const formWithLoan = {
                ...pendingForm,
                loanApplication: loanApplication
            };
            console.log('派車單含借車申請:', formWithLoan);
            onSubmit(formWithLoan);
            setPendingForm(null);
        }
    };

    const handleLoanFormCancel = () => {
        setShowLoanForm(false);
        // 保留 loanFormData，下次打開時還能繼續填寫
        // setPendingForm 也保留，這樣用戶可以繼續編輯
    };

    // 如果顯示借車申請表單
    if (showLoanForm) {
        return (
            <div className="truckLoanApplicationForm custom-modal-backdrop">
                <div className="custom-modal" style={{ width: '1200px', maxHeight: '90vh', overflow: 'auto' }}>
                    <TruckLoanApplicationForm
                        mode="embedded"
                        vehicleInfo={vehicleInfo}
                        deliverInfo={{
                            id: form.employeeId,
                            name: form.name,
                            phone: form.phone,
                            company: form.company,
                        }}
                        deliverOrderInfo={{
                            usedAt: form.usedAt,
                            finishAt: form.finishAt,
                            returnAt: form.returnAt,
                            category: form.category,
                        }}
                        initialData={loanFormData}
                        onDataChange={setLoanFormData}
                        onSubmit={handleLoanFormSubmit}
                        onCancel={handleLoanFormCancel}
                    />
                </div>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="custom-modal-backdrop">
                <div className="custom-modal">
                    <div className="custom-modal-header">
                        <h5 className="modal-title">填寫派車單</h5>
                        <button className="btn-close" onClick={onCancel}></button>
                    </div>
                    <div className="custom-modal-body">
                        {/* 模式選擇 - 只在 propMode = 'deliver' 時顯示 */}
                        {propMode === 'deliver' && (
                            <div className="input-group mb-3">
                                <span className="input-group-text">派車單類型</span>
                                <select
                                    className="form-select"
                                    value={selectedMode}
                                    onChange={(e) => {
                                        setSelectedMode(e.target.value);
                                        // 清空所有表單資訊
                                        setForm({
                                            company: '',
                                            employeeId: '',
                                            name: '',
                                            plate: '',
                                            phone: '',
                                            furnitureCount: 0,
                                            usedAt: '',
                                            finishAt: '',
                                            returnAt: '',
                                        });
                                    }}
                                >
                                    <option value="personal">個人司機</option>
                                    <option value="company">公司司機</option>
                                </select>
                            </div>
                        )}

                        {/* 司機 */}
                        <div className="input-group mb-3">
                            <span className="input-group-text">司機</span>
                            <select
                                className="form-select"
                                name='name'
                                value={form.name}
                                onChange={handleChange}
                                required
                            >
                                <option disabled value="">請選擇司機</option>
                                {
                                    deliversData
                                        .filter(deliver =>
                                            (mode === 'personal' && !deliver.company) ||
                                            (mode === 'company' && deliver.company)
                                        )
                                        .map(deliver =>
                                            <option key={deliver.id} data-id={deliver.id} value={deliver.name}>
                                                {deliver.name}
                                            </option>)
                                }

                            </select>
                        </div>

                        {/* 車牌 - 個人模式自動填入，公司模式可選擇 */}
                        {mode === 'personal' ? (
                            <div className="input-group mb-3">
                                <span className="input-group-text">
                                    車牌
                                    <span className="required-star">*</span>
                                </span>
                                <input
                                    type="text"
                                    className="form-control"
                                    name='plate'
                                    value={form.plate}
                                    disabled
                                    placeholder="選擇司機後自動填入"
                                />
                            </div>
                        ) : (
                            <div className="input-group mb-3">
                                <span className="input-group-text">
                                    車牌
                                    <span className="required-star">*</span>
                                </span>
                                <select
                                    className="form-select"
                                    name='plate'
                                    value={form.plate}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">請選擇車牌</option>
                                    {form.name && deliversData.find(deliver => deliver.name === form.name)?.vehicles?.length > 0 ? (
                                        deliversData
                                            .find(deliver => deliver.name === form.name)
                                            ?.vehicles?.map(vehicle => (
                                                <option key={vehicle.id} value={vehicle.plate}>
                                                    {vehicle.plate} ({vehicle.model})
                                                </option>
                                            ))
                                    ) : (
                                        form.name && <option disabled>無資料</option>
                                    )}
                                </select>
                            </div>
                        )}

                        {/* 基本資訊 */}
                        {CreateStaffOrderModalList
                            .filter(field => (!field.mode || field.mode === mode) && field.name !== 'plate')
                            .map(field => (
                                <div className="input-group mb-3" key={field.name}>
                                    <span className="input-group-text">
                                        {field.label}
                                        {form.company === '順康資產管理顧問股份有限公司' && field.name === "returnAt" ? <span className="required-star">*</span> : field.required && <span className="required-star">*</span>}
                                    </span>
                                    <input
                                        type={field.type}
                                        className="form-control"
                                        name={field.name}
                                        value={form[field.name]}
                                        onChange={handleChange}
                                        placeholder={field.placeholder || ""}
                                        required={form.company === '順康資產管理顧問股份有限公司' && field.name === "returnAt" ? true : field.required}
                                        pattern={field.pattern}
                                        title={field.title}
                                        max={field.max}
                                        min={field.min}
                                        disabled={field.disabled}
                                    />
                                </div>
                            ))}
                    </div>
                    <div className="custom-modal-footer">
                        <div className="form-check form-switch">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="category"
                                name="category"
                                checked={form.category === 1}
                                onChange={(e) => {
                                    setForm(prev => ({
                                        ...prev,
                                        category: e.target.checked ? 1 : 2
                                    }));
                                }}
                            />
                            <label className="form-check-label" htmlFor="category">
                                提供送貨服務
                            </label>
                        </div>
                        <div className="d-flex gap-2">
                            {/* 順康公司才顯示填寫申請單按鈕 */}
                            {/* {form.company === '順康資產管理顧問股份有限公司' && (
                                <button
                                    type="button"
                                    className="btn btn-info"
                                    onClick={() => {
                                        if (!form.name) {
                                            Message('請先選擇司機', 'warning');
                                            return;
                                        }
                                        if (!form.plate) {
                                            Message('請先選擇車牌', 'warning');
                                            return;
                                        }
                                        setPendingForm(form);
                                        setShowLoanForm(true);
                                    }}
                                >
                                    填寫借車申請單
                                </button>
                            )} */}
                            <button className="btn btn-secondary" onClick={onCancel}>取消</button>
                            <button className="btn btn-gradient-primary" type="submit">儲存</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

export { CreateStaffOrderModal };
